const APIKEY = 'a539db8dfbcfbbaa8efb4a9911e4312e';
const baseUrl = 'https://api.openweathermap.org/data/2.5/';
const requestAction = 'forecast';
const apiUrl = `${baseUrl}${requestAction}?appid=${APIKEY}`;
// api.openweathermap.org/data/2.5/forecast?q=Athens,gr&appid=a539db8dfbcfbbaa8efb4a9911e4312e

export async function getForecast(axios, moment, { lat, lng }) {
	const result = await axios.get(`${apiUrl}&lat=${lat}&lon=${lng}`);

	if (result.data.cod != 200) {
		return result;
	}

	// result.list contains the data we need
	const resolvedData = result.data.list.map(x => {
		return {
			...x,
			dateTime: moment.unix(x.dt).format('DD MMM YYYY hh:mm a'),
		};
	});

	return resolvedData;
}
